import * as t from 'io-ts';
import { createLocalStorageItem } from 'src/domains/layouts/state/localStorage/createLocalStorageItem';
import { LocalStorageItemState } from 'src/domains/layouts/state/localStorage/LocalStorageItemState';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';

export type BetGliderLaunchUrlCacheEntryType = {
    url: string;
    expiresAt: number;
    userId: number;
    eventId: number;
    universe: string;
};

const decodeIO = t.union([
    t.type({
        url: t.string,
        expiresAt: t.number,
        userId: t.number,
        eventId: t.number,
        universe: t.string,
    }),
    t.null,
]);

const decode = buildValidator('localStorageBetGliderLaunchUrl.decodeIO', decodeIO, true);

export const localStorageBetGliderLaunchUrl = (
    withAutorun: boolean,
    key: string
): LocalStorageItemState<BetGliderLaunchUrlCacheEntryType | null> => {
    return createLocalStorageItem(withAutorun, {
        key,
        decode,
        defaultValue: null,
    });
};
